import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { fonts } from '@/theme';
import { useModeTokens } from './useModeTokens';

interface MonoProps {
  children?: React.ReactNode;
  /** Font size in px. The design uses 9–12px for metadata. */
  size?: number;
  weight?: 400 | 500 | 600 | 700;
  color?: string;
  /** Extra tracking, e.g. '0.1em' for uppercase labels. */
  letterSpacing?: string;
  /** Pin to one mode instead of following the theme. */
  light?: boolean;
  component?: React.ElementType;
  sx?: SxProps<Theme>;
}

/**
 * Metadata voice. Counts, sizes, timestamps, file specs and status text are all
 * set in JetBrains Mono — it is what separates "data about the session" from
 * "the session's own name", without needing a second colour.
 */
export const Mono: React.FC<MonoProps> = ({
  children,
  size = 11,
  weight = 500,
  color,
  letterSpacing,
  light,
  component = 'span',
  sx,
}) => {
  const t = useModeTokens(light);

  return (
    <Box
      component={component}
      sx={{
        fontFamily: fonts.mono,
        fontWeight: weight,
        fontSize: `${size}px`,
        lineHeight: 1.2,
        color: color ?? t.text.muted,
        letterSpacing,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default Mono;
